export default theme => ({
  root: {
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    '&[class*="isSelected"]': {
      '& [class*="selector"]': {
        opacity: '1'
      }
    },
    // Add a height 0px to the rc-menu-submenu-popup parent, to prevent it to interfiere with the menu icon "hover" event
    // If not set the height, in certain screen positions, the popover opens and close sequentially on hover.
    // The rc-menu-submenu-popup is displayed on the root scope because we set it explicitly passing a the ref of the root element
    '& div:has(> .rc-menu-submenu-popup)': {
      height: '0px'
    }
  },
  selector: {
    position: 'absolute',
    top: 0,
    left: 0,
    marginTop: '3px',
    paddingRight: '16px'
  },
  isSelected: {},
  title: {
    display: 'block',
    margin: '0 34px'
  },
  actions: {
    position: 'absolute',
    right: 0,
    top: '-4px',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    padding: '6px 8px',
    backgroundColor: theme.colors.primary.white,
    borderRadius: '4px',
    boxShadow: '0px 2px 4px 0px rgba(39, 60, 80, 0.14), 0px 3px 4px 0px rgba(39, 60, 80, 0.12), 0px 1px 5px 0px rgba(39, 60, 80, 0.20)',
    '& .rc-menu-submenu-title': {
      paddingBottom: 0,
      '& span': {
        marginRight: 0
      }
    }
  },
  noActions: {
    display: 'none'
  },
  menuOpen: {},
  menuPopover: {
    zIndex: 1
  }
});